import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuex from "vuex";

import serverAPI from "./api/serverAPI";

Vue.prototype.$server = serverAPI;

Vue.config.productionTip = false;

Vue.use(Vuex);

// 권한 레벨 파싱 헬퍼 (구 배열 포맷 → 객체 포맷 자동 변환)
function _parsePerms(user) {
  if (!user) return {};
  let p;
  try { p = JSON.parse(user.permissions || '{}'); } catch { p = {}; }
  if (Array.isArray(p)) {
    const obj = {};
    p.forEach(k => { obj[k] = 'write'; }); // 구 포맷: 모두 write 레벨로 간주
    return obj;
  }
  return p;
}

// 등록(신규행) 가능 여부: 'write' 또는 'edit' 레벨
Vue.prototype.$canWrite = function(pageKey) {
  const user = this.$store.state.auth.user;
  if (!user) return false;
  if (user.roles && user.roles.includes('ROLE_ADMIN')) return true;
  const p = _parsePerms(user);
  const level = p[pageKey];
  return level === 'write' || level === 'edit';
};

// 수정 가능 여부: 'edit' 레벨만
Vue.prototype.$canEdit = function(pageKey) {
  const user = this.$store.state.auth.user;
  if (!user) return false;
  if (user.roles && user.roles.includes('ROLE_ADMIN')) return true;
  const p = _parsePerms(user);
  return p[pageKey] === 'edit';
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
